import { ReactNode } from "react";

type Props = {
  children?: ReactNode;
  title?: ReactNode;
  center?: ReactNode;
  actions?: ReactNode;
};

export const PageLayout = ({ children, title, center, actions }: Props) => {
  return (
    <div className="container flex flex-col gap-y-2">
      <div className="h-12 flex flex-row items-center px-4 justify-between">
        <div>
          <p className="font-bold text-xl">{title}</p>
        </div>

        <div>{center}</div>

        <div className="flex flex-row justify-end gap-x-2">{actions}</div>
      </div>

      {children}
    </div>
  );
};
